import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formPropType } from 'utils/propType';
import autobind from 'react-autobind';
import translate from 'app/translations';
import {
  Form, Input, Row, Col, Button,
} from 'antd';

import { FormControl, FormRules } from 'form-control';

const { TextArea } = Input;

export class PostMessageComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  handleSave(e) {
    e.preventDefault();
    this.props.form.validateFields((errors, values) => {
      if (!errors) {
        this.props.onAddMessage(values.message);
        this.props.form.resetFields();
      }
    });
  }

  render() {
    return (
      <div>
        <Form>
          <Row gutter={32}>
            <Col span={24}>
              <FormControl
                form={this.props.form}
                fieldName="message"
                displayName={this.t('PostMessage.messageTxt')}
                initialValue={undefined}
                rules={[FormRules.REQUIRED, { [FormRules.MAXLENGTH]: 10000 }]}
              >
                <TextArea autosize placeholder={this.t('PostMessage.messageTxt')} />
              </FormControl>
            </Col>
          </Row>
          <Row gutter={32}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                htmlType="submit"
                id="submitMessage"
                onClick={this.handleSave}
              >
                {this.t('PostMessage.post')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

PostMessageComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  onAddMessage: PropTypes.func.isRequired,
};

export default Form.create()(PostMessageComponent);
